export enum MimeTypes {
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}
